export type CanonicalLoyaltyEarnResultSnapshot = {
  id?: string;
  result_status?: string;
  amount_basis?: string;
  basis_amount?: number;
  base_points?: number;
  promotion_bonus_points?: number;
  total_points?: number;
  base_earn_policy_version_no?: number;
  base_earn_policy_scope_type?: string;
  base_earn_policy_branch_id?: string | null;
  committed_at?: string;
};

export type CanonicalLoyaltyPointSummary = {
  ok?: boolean;
  ready?: boolean;
  contract?: string;
  owner?: string;
  customer_id?: string;
  current_balance?: number;
  lifetime_positive_points?: number;
  ledger_event_count?: number;
  derived_from?: string;
};

export type CanonicalLoyaltyEarnAck = {
  ok?: boolean;
  committed?: boolean;
  ready?: boolean;
  contract?: string;
  reason_code?: string;
  source_order_id?: string;
  idempotent_replay?: boolean;
  diagnostic_code?: string;
  diagnostic_message?: string;
  earn_result?: CanonicalLoyaltyEarnResultSnapshot | null;
  point_summary?: CanonicalLoyaltyPointSummary | null;
};

export type PosLoyaltyEarnAckEventDetail = {
  orderId: string;
  orderNo: string;
  loyaltyEarn: CanonicalLoyaltyEarnAck | null;
};

export const POS_LOYALTY_EARN_ACK_EVENT = "more:pos:loyalty-earn-ack";

export function publishPosLoyaltyEarnAck(detail: PosLoyaltyEarnAckEventDetail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<PosLoyaltyEarnAckEventDetail>(POS_LOYALTY_EARN_ACK_EVENT, { detail }));
}

export function subscribePosLoyaltyEarnAck(listener: (detail: PosLoyaltyEarnAckEventDetail) => void) {
  if (typeof window === "undefined") return () => undefined;
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<PosLoyaltyEarnAckEventDetail>).detail;
    if (detail?.orderId) listener(detail);
  };
  window.addEventListener(POS_LOYALTY_EARN_ACK_EVENT, handler);
  return () => window.removeEventListener(POS_LOYALTY_EARN_ACK_EVENT, handler);
}
